import ContentLoader from "react-content-loader";
import Image from "../image/Image";

export const LoadingPricingPlan = () => (
  <div className="mt-8 flex flex-col px-6 py-4.5 rounded-3xl bg-neutral-100 border border-neutral-200 w-full">
    <div>
      <ContentLoader width="100%" height="96px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="12" ry="12" width="100%" height={96} />
      </ContentLoader>
    </div>
    <div className="mt-[2.125rem]">
      <ContentLoader width="100%" height="52px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="12" ry="12" width="100%" height={52} />
      </ContentLoader>
    </div>
    <div className="mt-[2.125rem]">
      <ContentLoader width="100%" height="48px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="40" ry="40" width="100%" height={48} />
      </ContentLoader>
    </div>
    <div className="mt-[2.125rem]">
      <ContentLoader width="100%" height="30px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="8" ry="8" width="100%" height={30} />
      </ContentLoader>
    </div>
    <div className="mt-3">
      <ContentLoader width="100%" height="30px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="8" ry="8" width="70%" height={30} />
      </ContentLoader>
    </div>
    <div className="mt-3">
      <ContentLoader width="100%" height="30px" foregroundColor="#EDF2F7">
        <rect x="0" y="0" rx="8" ry="8" width="50%" height={30} />
      </ContentLoader>
    </div>
  </div>
);

export const LoadingMap = () => (
  <div className="w-full h-full rounded-[0.875rem] bg-neutral-200 flex flex-col justify-between p-4.5">
    <div>
      <ContentLoader width="100%" height="72px" foregroundColor="#E2E8F0">
        <rect x="0" y="0" rx="40" ry="40" width="100%" height={72} />
      </ContentLoader>
    </div>
    <div>
      <ContentLoader width="100%" height="64px" foregroundColor="#E2E8F0">
        <rect x="0" y="0" rx="12" ry="12" width="100%" height={64} />
      </ContentLoader>
    </div>
  </div>
);

export const LoadingFacility = () => (
  <tr>
    <td scope="row" className="p-3 flex flex-row items-center space-x-2">
      <div className="w-[2.5rem]">
        <ContentLoader width="100%" height="40px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="12" ry="12" width="100%" height={40} />
        </ContentLoader>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="">
          <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
            <rect x="0" y="0" rx="6" ry="6" width="100%" height={16} />
          </ContentLoader>
        </div>
        <div className="">
          <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
            <rect x="0" y="0" rx="6" ry="6" width="50%" height={14} />
          </ContentLoader>
        </div>
      </div>
    </td>
    <td className="p-3 ">
      <div className="">
        <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="6" ry="6" width="100%" height={16} />
        </ContentLoader>
      </div>
      <div className="mt-2">
        <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="6" ry="6" width="50%" height={14} />
        </ContentLoader>
      </div>
    </td>
    <td className="p-3 ">
      <div className="">
        <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="6" ry="6" width="100%" height={16} />
        </ContentLoader>
      </div>
      <div className="mt-2">
        <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="6" ry="6" width="50%" height={14} />
        </ContentLoader>
      </div>
    </td>
    <td className="p-3 ">
      <div className="">
        <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="6" ry="6" width="100%" height={16} />
        </ContentLoader>
      </div>
      <div className="mt-2">
        <ContentLoader width="100%" height="16px" foregroundColor="#E2E8F0">
          <rect x="0" y="0" rx="6" ry="6" width="50%" height={14} />
        </ContentLoader>
      </div>
    </td>
  </tr>
);

export const LoadingFaq = () => (
  <div className="w-full h-[4.5rem]">
    <ContentLoader width="100%" height="72px" foregroundColor="#EDF2F7">
      <rect x="0" y="0" rx="14" ry="14" width="100%" height={72} />
    </ContentLoader>
  </div>
);

export const NotFound = (props:any) => (
  <div className="flex flex-col justify-center items-center h-full text-center w-full">
    <Image
      src="/images/illustration/box.svg"
      alt="Not Found"
      className="w-[7.75rem] h-[7.75rem] mt-9"
    />
    <div className="mt-7">
      <b className="text-neutral-900 text-title3">No Records</b>
      <p className="text-neutral-600 text-regular-tight mt-4.5">
        there’s no any {props.message || "records"} found
      </p>
    </div>
  </div>
);

export const LoadingBlog = () => (
  <>
    <div className="flex flex-col">
      <div className="">
        <ContentLoader width="100%" height="250px" foregroundColor="#EDF2F7">
          <rect x="0" y="0" rx="14" ry="14" width="100%" height="250" />
        </ContentLoader>
      </div>
      <div className="mt-3.5">
        <ContentLoader width="100%" height="20px" foregroundColor="#EDF2F7">
          <rect x="0" y="0" rx="6" ry="6" width="110" height="20" />
        </ContentLoader>
      </div>
      <div className="mt-3.5">
        <ContentLoader width="100%" height="34px" foregroundColor="#EDF2F7">
          <rect x="0" y="0" rx="8" ry="8" width="222" height="34" />
        </ContentLoader>
      </div>
      <div className="mt-2">
        <ContentLoader width="100%" height="112px" foregroundColor="#EDF2F7">
          <rect x="0" y="0" rx="8" ry="8" width="100%" height="112" />
        </ContentLoader>
      </div>
    </div>
  </>
);
